import React, { FC } from 'react';
import ImageCard from './imageCard';

interface Props {
  item: any;
  handleChange: (uuid: string, value: string) => void;
}

const AltTagCard: FC<Props> = ({ item, handleChange }) => {
  return (
    <div
      className="w-100 bg-white p-2 rounded-3 d-flex gap-3 align-items-center shadow-sm "
      style={{ height: 120 }}
    >
      <div className="">
        <ImageCard item={item} image={item?.preview_image} />
      </div>

      <div className="w-100 d-flex flex-column h-100">
        <textarea
          className="flex-grow-1 w-100 border border-secondary p-2 rounded-3"
          maxLength={1000}
          value={item?.media_alt_description}
          onChange={(e) => handleChange(item.uuid, e.target.value)}
          style={{ outline: 'none', boxShadow: 'none' }}
        ></textarea>
      </div>
    </div>
  );
};

export default AltTagCard;
